export enum SuggestionServiceType {
    NewService = 1,
    SenderNameRegistration = 2,
    ContractRequest = 3,
    RenewalRequest = 4,
    ConnectivityRequest = 5,
    Payment = 6
  }  